import { useState as n, useMemo as r } from "react";
const f = (e) => {
  const [s, t] = n(!!e), o = r(() => ({ set: t, setFalse: () => t(!1), setTrue: () => t(!0), toggle: () => t((a) => !a) }), []);
  return [s, o];
};
export {
  f as default
};
//# sourceMappingURL=useBoolean.js.map
